module.exports = "/virtual-football/img/video/clubs/england/arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/england/arsenal.png
// module id = 284
// module chunks = 6